import React, { Component } from 'react';
import { Spin, Row, Button, Input, Result, notification } from 'antd';
import Form from '../../lib/ui/form';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { schema_to_field, showErrorInNotification } from '../../lib/util';
import Text from 'antd/lib/typography/Text';
import { Link } from 'react-router-dom';
import Title from 'antd/lib/typography/Title';
import { BasicHeader } from '../../components/basic_header';
import { CustomButton } from '../../components/basic_items';
import { COLORS } from '../theme';

class ReportCreator extends Component {
  constructor(props) {
    super(props)

    this.plugin_id = props.match.params.adhoc_id;

    this.state = {
      loading: true,
      schema: [],
      form_data: {},
      name: null,
      generating_report: false,
      generated: false,
      generated_data: {}
    }

    this.get_report_plugin = RESTExecutor.detail().config({
      label: 'report_plugins_detail'
    }).forId(this.plugin_id).callbacks((success) => {

      this.setState({ schema: schema_to_field(success.result.validation_config), loading: false })
    }).connect(props.domains.reports);

    this.get_report_plugin.execute();

    this.generate_report = RESTExecutor.post().config({
      label: 'generate_report'
    }).callbacks((success) => {
      this.setState({ generating_report: false, generated: true, generated_data: success.result })
      console.log("success", success);
      notification.success({
        message:success.result.message||"Report generation action completed",
        type:success.result.success?'success':'error',
      });

      try{
        window.header.refreshNotifiicationCount(3000);
        }catch(e){

        }
    }, (error) => {
      this.setState({ generating_report: false })
      showErrorInNotification(error)
    }).connect(props.domains.reports);

  }

  generateReport = () => {
    let data = {};
    this.setState({ generating_report: true })
    data['plugin_id'] = this.plugin_id;
    data['params'] = this.state.form_data;
    data['name'] = this.state.name;
    this.generate_report.execute(data);
  }

  render() {

    if (this.state.loading) { return <center><Spin />     </center> }

    const { schema, form_data, generating_report, name, generated, generated_data } = this.state;

    // if (generated) {
    //   return <div
    //     className='default-card'
    //     style={{
    //       padding: 8
    //     }}>
    //     `  
    //     <Result
    //       status="success"
    //       title="Report Generated Successfully!"
    //       subTitle="Report Detail"
    //       extra={[
    //         <Link to={(`/reports/inbox/${generated_data.response_id}`)}>
    //           <Button type="primary" key="view">
    //             View Report
    //             </Button></Link>,
    //         <Button key="again" onClick={() => {
    //           this.setState({
    //             generated: false,
    //             generated_data: {}
    //           })
    //         }}>Generate Again</Button>,
    //       ]}
    //     />
    //   </div>
    // }


    return (
      <div>
        <BasicHeader
          title="Create Report"
          subtitle="Create Report"
        />
        <div
          className='default-card'
          style={{
            padding: 20
          }}>
          <span style={{
            fontWeight: 'bold',
            fontSize: 16,
            lineHeight: '20px',
          }}>PLUGIN : {this.plugin_id}</span>


          <Input
            autoFocus
            value={name}
            style={{
              marginTop:40,
            }}
            size='large'
            className='custom-input'
            placeholder="Report Name"
            onChange={(e) => {
              this.setState({ name: e.target.value })
            }}
          />
        </div>



        <div
          className='default-card'
          style={{
            padding: 20,
            paddingBottom: 40,
            paddingRight: '50%'
          }}>
          {schema.length === 0
            ? <span style={{
              fontWeight: 'bold',
              fontSize: 16,
              lineHeight: '20px',
            }}>No Params Needed</span>
            : <React.Fragment>
              <span style={{
                fontWeight: 'bold',
                fontSize: 16,
                lineHeight: '20px',
              }}>Report Params</span>

              <Form
                hideTitle
                forCreate={true}
                initialData={form_data}
                submitted={this.state.submitted}
                onChange={(xx) => {
                  console.log("Changes", xx);
                  this.setState({ form_data:xx })
                }}
                fields={this.state.schema}
                submitting={{}}
                errorMessage={{}}
                validationErrors={{}} />
            </React.Fragment>}



          <CustomButton
            style={{
              marginTop: 22
            }}
            className='primary-btn'
            onClick={() => {
              this.generateReport();
            }}
            disabled={generating_report}
            label={generating_report ? "GENERATING.." : "GENERATE"}
          />


        </div>
      </div>
    );
  }
  componentDidUpdate = (prevProps) => {
    if (this.props.match.params.adhoc_id !== prevProps.match.params.adhoc_id) {
      this.plugin_id = this.props.match.params.adhoc_id;
      this.setState({ loading: true, form_data: {}, name: null })
      this.get_report_plugin.forId(this.plugin_id).execute();
      // product based and set it to the state of the component
    };
  };

}

export default withDomains(ReportCreator, "reports");
